<template>
  <v-layout row wrap align-start align-content-start class="mb-2 metadata-rules-search">
    <!-- Title and Tabs -->
    <v-flex xs12>
      <v-toolbar tabs color="secondary" class="elevation-0">
        <v-icon class="mr-0 indigo--text text--lighten-5">gavel</v-icon>
        <v-toolbar-title class="white--text subheading ttu">
          {{ messages.label.METADATA_RULES }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- Create Menu -->
        <v-menu offset-y>
          <v-btn slot="activator" color="accent" flat>
            <v-icon left>add_circle</v-icon><span>{{ messages.label.CREATE }}</span>
            <v-icon right>arrow_drop_down</v-icon>
          </v-btn>
          <v-list class="secondary white--text">
            <v-list-tile v-for="(item, index) in createMenuItems" :to="{ name: item.pathName }" :key="index">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-flex>
    <!-- Main Content -->
    <v-layout>
      <v-flex xs12>
        <MetadataRulesSearchFilter />
        <v-layout wrap>
          <v-flex :xs12="!ruleQuickView" :xs4="ruleQuickView">
            <MetadataRulesSearchResult />
          </v-flex>
          <v-flex :xs8="ruleQuickView" v-show="ruleQuickView" class="pl-0 side-sheet-container set-height">
            <RuleQuickView v-show="ruleGrouping === 'rules'"></RuleQuickView>
            <RuleSetQuickView v-show="ruleGrouping === 'ruleSets'"></RuleSetQuickView>
            <RuleCollectionQuickView v-show="ruleGrouping === 'ruleCollection'"></RuleCollectionQuickView>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- Snackbar -->
    <v-flex xs12>
      <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import MetadataRulesSearchFilter from "@/MetadataRules/MetadataRulesSearchFilter"
import MetadataRulesSearchResult from "@/MetadataRules/MetadataRulesSearchResult"
import RuleQuickView from "@/MetadataRules/Rule/RuleQuickView"
import RuleSetQuickView from "@/MetadataRules/RuleSet/RuleSetQuickView"
import RuleCollectionQuickView from "@/MetadataRules/RuleCollection/RuleCollectionQuickView"
import messages from "@/MetadataRules/messages.json"
import MetadataRulesService from "@/MetadataRules/MetadataRulesService"
import AppService from "@/AppService"
import { SET_RULE_QUICK_VIEW } from "@/store/constants/mutation-types"

/**
 * initialData
 */
function initialData(instance) {
  return {
    snackbar: {
      show: false,
      timeout: 3000,
      color: "error",
      message: ""
    },
    createMenuItems: instance.getCreateMenuItems(),
    ruleGrouping: "",
    crudRuleOperationType: "",
    crudRuleOperations: false
  }
}
export default {
  name: "MetadataRulesSearch",
  components: {
    MetadataRulesSearchFilter,
    MetadataRulesSearchResult,
    RuleQuickView,
    RuleSetQuickView,
    RuleCollectionQuickView
  },
  data: function () {
    return initialData(this)
  },
  computed: {
    ...mapState("metadataRules", [
      "ruleQuickView"
    ])
  },
  methods: {
    ...mapMutations("metadataRules", [
      SET_RULE_QUICK_VIEW
    ]),

    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * getContextTabs
     * @returns {array}
     */
    getContextTabs() {
      return [
        {
          title: "Global",
          pathName: "MetadataRulesSearch"
        },
        {
          title: "Provider",
          pathName: "MetadataRulesSearchProvider"
        }
      ]
    },

    /**
     * getCreateMenuItems
     * @returns {array}
     */
    getCreateMenuItems() {
      return [
        {
          title: "Rule",
          pathName: "ManageRule"
        },
        {
          title: "Rule Set",
          pathName: "ManageRuleSet"
        },
        {
          title: "Rule Collection",
          pathName: "ManageRuleCollection"
        }
      ]
    },

    /**
     * showSnackBar - display snackBar
     */
    showSnackBar(ruleType) {
      if (!this.$lodash.isUndefined(ruleType)) {
        this.snackbar.show = true
        this.snackbar.color = "success"
        switch (ruleType) {
          case "rule":
            this.snackbar.message = this.messages.info.RULE_CREATE_SUCCESS
            break
          case "ruleSet":
            this.snackbar.message = this.messages.info.RULESET_CREATE_SUCCESS
            break
          case "ruleCollection":
            this.snackbar.message = this.messages.info.RULECOLLECTION_CREATE_SUCCESS
            break
        }
      }
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
    MetadataRulesService.$on("event:showRuleQuickView", () => {
      this.ruleGrouping = "rules"
    })
    MetadataRulesService.$on("event:showRuleSetQuickView", () => {
      this.ruleGrouping = "ruleSets"
    })
    MetadataRulesService.$on("event:showRuleCollectionQuickView", () => {
      this.ruleGrouping = "ruleCollection"
    })
    MetadataRulesService.$on("event:showCopyRuleSuccessSnackBar", (ruleType) => {
      this.showSnackBar(ruleType)
    })
    MetadataRulesService.$on("event:showOverrideRuleSuccessSnackBar", (ruleType) => {
      this.showSnackBar(ruleType)
    })
    AppService.$on("event:preIngestServerError", () => {
      this.snackbar.show = true
      this.snackbar.color = "error"
      this.snackbar.message = this.messages.error.SERVER_ERROR
    })
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style lang="scss">
.metadata-rules-search .tabs-extension {
  height: 48px;
}

.side-sheet-container {
  align-self: stretch;
}

.side-sheet-container {
  align-self: stretch;
}

.set-height {
  max-height: 600px;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/MetadataRules/MetadataRulesSearch.vue